export default {
    props: {
      options: {}
    },
    data(){
      return {
        dateFormat: 'YYYY-MM-DD HH:mm:ss',
        dueDateFormat: 'YYYY-MM-DD',
        strDateFormat: 'YYYY년 MM월 DD일'
      }
    },
    computed: {
      getDueDateFormat() {
        return (from, to, format, splitStr) => {
          return moment(Number(from)).format(format) + splitStr + moment(Number(to)).format(format);
        }
      },
      getDueDate() {
        return (from, to) => {
          return moment(Number(from)).format(this.dueDateFormat) +' ~ ' + moment(Number(to)).format(this.dueDateFormat);
        }
      },
      getDateFormat(){
        return (date, format) => {
          return moment(Number(date)).format(format);
        }
      },
      getDate(){
        return (date) =>{

          if(date)
            return moment(Number(date)).format(this.dateFormat);
        }
      },
      getDateSimple(){
        return (date) =>{

          if(date)
            return moment(Number(date)).format(this.dueDateFormat);
        }
      },
      getDateSimpleStr() {
        return (date) => {

          if (date)
            return moment(Number(date)).format(this.strDateFormat);
        }
      }
      /*
      dateFormat() {
        return 'YYYY-MM-DD HH:mm:ss'
      }
      */
    },
    watch: {
      $route (newVal, oldBal) {
        this.closeModal()
      }
    },
    created: function () {
      //this.loadOptions()
    },
    methods: {
      debug () {
        debugger
      },
      go (view) {
        this.$router.push(view)
      },
      openModal (event) {
        if (typeof event.view === 'string') {
          event.view = this.loadComponent(event.view)
        }
        event.opener = event.opener || this
        event.id = this.uuidv4()
        this.$root.$emit('openModal', event)
      },
      closeModal () {
        this.$root.$emit('closeModal')
      },
      notify (event) {
        this.$root.$emit('notify', event)
      },
      self (key) {
        return this[key]
      },
      eval (exp) {
        return eval(exp)
      },
      loadComponent (path) {
        return () => new Promise(
          resolve => import('@/views/' + path + '.vue').then(
            (modules) => resolve(modules)
          ))
      },
      uuidv4 () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
          let r = Math.random() * 16 | 0
          let v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      },
      numberWithCommas (x) {
        if(!x)
          return '';
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      copyNew(x){
        return JSON.parse(JSON.stringify(x));
      },
      destory(){

        this.$destroy();
      },
      noti(title, message, type){
        $.notify({
          title: title,
          message: message
        }, {
          type: type
        });
      },

    }
  }
